import React from 'react';
import {
  Dialog, DialogContent, Box, Typography, Button, IconButton,
  List, ListItem, ListItemIcon, ListItemText,
  useMediaQuery, useTheme, Slide,
} from '@mui/material';
import {
  Close as CloseIcon,
  CheckCircleOutline as CheckIcon,
  RequestQuote as QuoteIcon,
} from '@mui/icons-material';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ServiceDetailDialog = ({ service, open, onClose, onRequestQuote }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!service) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 4,
          overflow: 'hidden',
        },
      }}
    >
      {/* Close button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute', top: 8, right: 8, zIndex: 10,
          bgcolor: 'rgba(255,255,255,0.85)',
          backdropFilter: 'blur(4px)',
          '&:hover': { bgcolor: 'rgba(255,255,255,0.95)' },
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Hero image */}
      <Box sx={{ height: { xs: 200, sm: 250 }, overflow: 'hidden', position: 'relative' }}>
        <Box
          component="img"
          src={service.image}
          alt={service.title}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        {/* Gradient overlay */}
        <Box sx={{
          position: 'absolute', bottom: 0, left: 0, right: 0, height: 80,
          background: 'linear-gradient(transparent, rgba(0,0,0,0.4))',
        }} />
      </Box>

      <DialogContent sx={{ p: { xs: 2.5, sm: 3.5 } }}>
        {/* Title with icon */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
          <Box sx={{
            width: 48, height: 48,
            borderRadius: 2.5,
            bgcolor: `${service.color}15`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: service.color,
            flexShrink: 0,
          }}>
            {React.cloneElement(service.icon, { sx: { fontSize: 28 } })}
          </Box>
          <Typography variant="h5" fontWeight="800" color="text.primary">
            {service.title}
          </Typography>
        </Box>

        {/* Long description */}
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mb: 3 }}>
          {service.longDescription}
        </Typography>

        {/* Details list */}
        <Typography variant="subtitle2" fontWeight="700" sx={{ mb: 1, color: service.color }}>
          Cosa include
        </Typography>
        <List dense disablePadding>
          {service.details.map((detail, i) => (
            <ListItem key={i} disableGutters sx={{ py: 0.4 }}>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <CheckIcon sx={{ fontSize: 20, color: service.color }} />
              </ListItemIcon>
              <ListItemText
                primary={detail}
                primaryTypographyProps={{ variant: 'body2', color: 'text.secondary', lineHeight: 1.6 }}
              />
            </ListItem>
          ))}
        </List>

        {/* CTA button */}
        <Button
          variant="contained"
          fullWidth
          size="large"
          startIcon={<QuoteIcon />}
          onClick={onRequestQuote}
          sx={{
            mt: 3,
            py: 1.5,
            borderRadius: 2.5,
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '1rem',
            bgcolor: service.color,
            '&:hover': { bgcolor: service.color, filter: 'brightness(0.9)' },
          }}
        >
          Richiedi Preventivo
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ServiceDetailDialog;
